import {Injectable} from '@angular/core';
import { HTTP_INTERCEPTORS, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {catchError, Observable, of, throwError} from 'rxjs';
import {TokenStorageService} from '../services/storage/token-storage.service';
import {Router} from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {KeycloakService} from "keycloak-angular";
import {LoginService} from '../services/login.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private tokenStorageService: TokenStorageService, private router: Router, private toastr: ToastrService,private keycloakService: KeycloakService, private loginService: LoginService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let authReq = request;
    
    // Check if request has Skip-Auth header (for public endpoints)
    const skipAuth = request.headers.has('Skip-Auth');
    
    if (skipAuth) {
      // Remove the Skip-Auth header and don't add authorization
      authReq = request.clone({
        headers: request.headers.delete('Skip-Auth')
      });
    } else {
      // Add authorization header for protected endpoints
      const token = this.tokenStorageService.getToken();
      if (token != null) {
        authReq = request.clone({headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token),});
      }
    }
    
    return next.handle(authReq).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
     // this.toastr.success('Auth Token Expired');
      this.tokenStorageService.signOut();
     // this.router.navigateByUrl('/docs');
      this.loginService.login();
      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }
}

export const authInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
];
